<template>
    <router-link
        :to="linkUrl"
        class="tile"
    >
        <div
            class="tile__header"
            :style="`background-image: url(${imageUrl})`"
        />

        <div class="tile__title">
            <div class="tile__label">{{ name }}</div>
        </div>
    </router-link>
</template>

<script>
export default {
    name: 'fanshop-tile',
    props: {
        imageUrl: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        linkUrl: {
            type: [String, Object],
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
a {
    text-decoration: none;
}

.tile {
    color: $cyprus-color;
    background-color: $white-color;
    transition: 0.05s ease-in;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 40rem;
    height: 21rem;
    border-radius: 1rem;
    padding-bottom: 1.5rem;
    margin: 2rem 2.5rem 3rem;
    justify-content: flex-end;

    @include max-width(320px) {
        width: 26.5rem;
    }

    &:hover {
        cursor: pointer;
        opacity: 0.8;
    }

    &__header {
        height: 20rem;
        width: 100%;
        background-size: cover;
        background-repeat: no-repeat;
    }

    &__title,
    &__label {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-weight: 700;
        text-transform: capitalize;
    }

    &__title {
        padding: 1.7rem 1.5rem 1.2rem;
    }

    &__label {
        font-size: 1.6rem;
        padding: 0 0.25rem;
    }
}
</style>